import Vue from 'vue';
import Question from '@/components/questions/Question.vue';
import QuestionLoader from '@/components/questions/QuestionLoader.vue';
import Question7 from '@/components/questions/Question7.vue';
import Question8 from '@/components/questions/Question8.vue';
import Question9 from '@/components/questions/Question9.vue';
import Question10 from '@/components/questions/Question10.vue';
import Question11 from '@/components/questions/Question11.vue';
import Question12 from '@/components/questions/Question12.vue';
import Question13 from '@/components/questions/Question13.vue';
import Question14 from '@/components/questions/Question14.vue';
import Question15 from '@/components/questions/Question15.vue';
import Question16 from '@/components/questions/Question16.vue';
//import Question17 from '@/components/questions/Question17.vue';
import QuestionText from '@/components/questions/QuestionText.vue';

Vue.component('wes-question', Question);
Vue.component('loader', QuestionLoader);
Vue.component('wes-q7', Question7);
Vue.component('wes-q8', Question8);
Vue.component('wes-q9', Question9);
Vue.component('wes-q10', Question10);
Vue.component('wes-q11', Question11);
Vue.component('wes-q12', Question12);
Vue.component('wes-q13', Question13);
Vue.component('wes-q14', Question14);
Vue.component('wes-q15', Question15);
Vue.component('wes-q16', Question16);
//Vue.component('wes-q17', Question17);
Vue.component('wes-q-text', QuestionText);
